export default "__VITE_ASSET__DXAeGQmF__"